module.exports = __webpack_public_path__ + "static/media/18ECA42.57134995.jpg";